import { post } from './index'

export function getUserList(params) {
  return post('/insurance/user/getUserList', params)
}

export function addUser(params) {
  return post('/insurance/user/addUser', params)
}

export function updateUser(params) {
  return post('/insurance/user/updateUser', params)
}

export function updatePartialInfo(params) {
  return post('/insurance/user/update/partialInfo', params)
}

export function getUserInfo(id) {
  return post('/insurance/user/get/userInfo', { id })
}
